import { create } from 'zustand'

import type { UserHeaderStore } from './useHeaderStore.types'

export const useHeaderStore = create<UserHeaderStore>((set, get) => ({
  title: '',
  setTitle: (title: string) => {
    const stateTitle = get().title
    if (title !== stateTitle) {
      set({
        title
      })
    }
  }
}))
